import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MeetingTypeService from "../../src/Services/MeetingType.service";
const MeetingTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<MeetingType[]>' is not assignable to type '(ids: string[]) => Promise<MeetingType[]>'.
        fetchItemsById: (ids) => {
            return MeetingTypeService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MeetingTypeService.searchAll(search);
        },
        optionRenderer: function optionRenderer(meetingType) {
            return _jsx("span", { children: meetingType.name });
        },
    });
};
export default MeetingTypeLookup;
